<template></template>

<script>
import notyMixin from "@/helpers/noty";
import { liveCoachJoinedNotification } from "./notifications";

export default {
  mixins: [notyMixin],
  props: ["channel"],
  created() {
    this.channel.bind("connection.opened", ({ participant }) => {
      if (participant.isGhost) {
        this.$_notificationsToCloseOnDestroy.push(
          liveCoachJoinedNotification({ name: participant.name }).show()
        );
      }
    });
  },
};
</script>



// WEBPACK FOOTER //
// connection-opened.vue?349bbeb2